/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Lead } from './Lead';
import { LeadFromJSON, LeadFromJSONTyped, LeadToJSON } from './Lead';
import type { DpCall } from './DpCall';
import { DpCallFromJSON, DpCallFromJSONTyped, DpCallToJSON } from './DpCall';
import type { LeadListItem } from './LeadListItem';
import {
  LeadListItemFromJSON,
  LeadListItemFromJSONTyped,
  LeadListItemToJSON,
} from './LeadListItem';

/**
 *
 * @export
 * @interface LeadItem
 */
export interface LeadItem {
  /**
   *
   * @type {LeadListItem}
   * @memberof LeadItem
   */
  item: LeadListItem;
  /**
   * the LeadListItem id
   * @type {string}
   * @memberof LeadItem
   */
  itemId: string;
  /**
   *
   * @type {DpCall}
   * @memberof LeadItem
   */
  lastCall: DpCall;
  /**
   *
   * @type {Lead}
   * @memberof LeadItem
   */
  lead: Lead;
}

/**
 * Check if a given object implements the LeadItem interface.
 */
export function instanceOfLeadItem(value: object): value is LeadItem {
  if (!('item' in value) || value['item'] === undefined) return false;
  if (!('itemId' in value) || value['itemId'] === undefined) return false;
  if (!('lastCall' in value) || value['lastCall'] === undefined) return false;
  if (!('lead' in value) || value['lead'] === undefined) return false;
  return true;
}

export function LeadItemFromJSON(json: any): LeadItem {
  return LeadItemFromJSONTyped(json, false);
}

export function LeadItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadItem {
  if (json == null) {
    return json;
  }
  return {
    item: LeadListItemFromJSON(json['item']),
    itemId: json['item_id'],
    lastCall: DpCallFromJSON(json['last_call']),
    lead: LeadFromJSON(json['lead']),
  };
}

export function LeadItemToJSON(value?: LeadItem | null): any {
  if (value == null) {
    return value;
  }
  return {
    item: LeadListItemToJSON(value['item']),
    item_id: value['itemId'],
    last_call: DpCallToJSON(value['lastCall']),
    lead: LeadToJSON(value['lead']),
  };
}
